import React from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { AlertCircle, Check, MessageCircle } from "lucide-react";

// Red-flag alerts across the trainer's clients.
const AlertsTab = ({
  alerts,
  clients,
  openClientEdit,
}) => {
  return (
    <div className="alerts-view">
      <div className="view-header">
        <h1>Alerts</h1>
      </div>

      {alerts.length === 0 ? (
        <Card className="empty-state success">
          <CardContent>
            <Check size={48} strokeWidth={1} />
            <h3>All good</h3>
            <p>No alerts at the moment</p>
          </CardContent>
        </Card>
      ) : (
        <div className="alerts-list">
          {alerts.map(alert => (
            <Card key={alert.id} className={`alert-card clickable-card ${alert.alert_type}`} onClick={() => {
              const client = clients.find(c => c.id === alert.client_id);
              if (client) openClientEdit(client);
            }}>
              <CardContent>
                <AlertCircle size={20} />
                <div className="alert-info">
                  <h3>{alert.client_name}</h3>
                  <p>{alert.message}</p>
                </div>
                <Button variant="outline" size="sm" onClick={(e) => {
                  e.stopPropagation();
                  const client = clients.find(c => c.id === alert.client_id);
                  if (client) openClientEdit(client);
                }}>
                  <MessageCircle size={14} /> Message
                </Button>
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
};

export default AlertsTab;
